import React, { useState, type FC, useCallback } from 'react';
import Button from '@atlaskit/button';
import Drawer from '@atlaskit/drawer';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { VirtualAgentConversationStateContainer } from '../controllers/conversation-store';
import { useVirtualAgentConversationProvider } from '../services/conversation-service';
import { Conversation } from './conversation';

export const VirtualAgentTrigger: FC = () => {
    const virtualAgentConversationProvider = useVirtualAgentConversationProvider();

    const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

    const openDrawer = useCallback(() => {
        setIsDrawerOpen(true);
    }, []);

    const closeDrawer = useCallback(() => {
        setIsDrawerOpen(false);
    }, []);

    return (
        // pass in the provider here (e.g. virtual agent service)
        <VirtualAgentConversationStateContainer conversationProvider={virtualAgentConversationProvider}>
            <Drawer zIndex={504} onClose={closeDrawer} isOpen={isDrawerOpen} width="full">
                <Box xcss={containerStyles}>
                    <Heading level="h600">Virtual Agent</Heading>
                    <Conversation />
                </Box>
            </Drawer>
            <Button onClick={openDrawer}>Talk to the virtual agent</Button>
        </VirtualAgentConversationStateContainer>
    );
};

const containerStyles = xcss({
    textAlign: 'center',
    width: 'calc(100vw - 64px)',
    marginLeft: '-32px',
    transform: 'translateX(32px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
});
